import type React from "react";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import ContactUsButton from "app/components/ContactUs/ContactUsButton";

import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SwDemoBanner: React.FC<{ type: string }> = ({ type }) => {
    function isUnauthorized() {
        return proNavigator.current().name.endsWith("unauthorized");
    }

    const isHaveBanner = swSettings.current.isHaveBanner && swSettings.current.isAllowed && !isUnauthorized();

    const subject =
        swSettings.current.componentId === "MobileWeb" ? "Sales/Enterprise/MobileWeb" : "Sales/Enterprise/PopularPages";
    const onCtaClick = () => {
        allTrackers.trackEvent("hook/Contact Us/Pop up", "click", "Demo Banner");
    };

    const translate = useTranslation();

    return isHaveBanner ? (
        <div className={`sw-demo-banner sw-demo-banner-${type}`}>
            <span>
                <b>{translate("demo.banner.message.text1")}</b> {translate("demo.banner.message.text2")}
            </span>
            <ContactUsButton
                text="demo.banner.btn.contactus"
                label="Demo Banner"
                onClick={onCtaClick}
            />
        </div>
    ) : null;
};
